import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { CompanyComponent } from 'src/app/company/company.component';
import { CompanyService } from 'src/app/services/company.service';
import { LoginService } from 'src/app/services/login.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { URI } from 'src/app/settings/uri-constants';

// #TODO Merge this component with the enterprise navigation component to reduce code duplication

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent {
    iconName: string = '';
    logoutModalDisplay = 'none';
    name: string = '';
    uri = URI;
    navigationItems = this.navService.getNavigationItems();
    expandedMenus: { [key: string]: boolean } = {};
    hasActiveChild: { [key: string]: boolean } = {};
    manuallyToggled: { [key: string]: boolean } = {};

    constructor(
        private router: Router,
        private navService: NavigationService,
        private loginService: LoginService,
        private dialog: MatDialog,
        public companyService: CompanyService,
    ) {
        this.iconName = 'logout-icon';
        this.name = this.loginService.sessionUser?.value?.name || '';
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.updateExpandedMenusByUrl(event.urlAfterRedirects);
                this.updateActiveParents();
            });
    }

    updateExpandedMenusByUrl(url: string) {
        this.navService.updateExpandedMenusByUrl(
            url,
            this.navigationItems,
            this.manuallyToggled,
            this.expandedMenus
        );
    }

    updateActiveParents() {
        this.navService.updateActiveParents(
            this.navigationItems,
            this.hasActiveChild
        );
    }

    toggleMenu(menuName: string, event: MouseEvent) {
        this.navService.toggleMenu(
            menuName,
            this.expandedMenus,
            this.manuallyToggled,
            event
        );
    }

    mouseEnter() {
        this.iconName = this.iconName === 'logout-icon' ? 'logout-hover' : 'logout-icon';
    }

    logout() {
        this.logoutModalDisplay = 'block';
    }

    closeModal() {
        this.logoutModalDisplay = 'none';
    }

    submit() {
        this.loginService.logout();
    }

    openCompanyDropDown(event: any) {
        this.dialog.open(CompanyComponent);
    }
}
